<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">智能回收柜</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img width="90%" class="oneBodyImgCls" src="../assets/images/blhsg03_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">智能回收柜</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          智能回收柜是一款放置在小区室外公共区域的智能设备，主要用于居民自助投放废品（如纸类、塑料、金属、织物、有害垃圾）。居民可凭手机APP、智能IC卡、人脸识别任何一种方式进行身份识别，选择需要投放废品的种类。设备内具备称重功能，进行称重后掉落到存储空间。此产品实现小区居民废品的快速交投，并通过用户识别及称重，实现实时废品线上奖励。可以实现基础再生资源、图书、织物等物品的回收。
        </div>
      </div>


      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">主柜+副柜尺寸：1450mm(宽)*896mm(厚)*1905mm(高)</div>
      <div class="center_two_e">大副柜尺寸：850mm(宽)*896mm(厚)*1905mm(高)</div>
      <div class="center_two_e">小副柜尺寸：700mm(宽)*896mm(厚)*1905mm(高)</div>
      <div class="center_two_e">带雨棚尺寸：1450/850/700mm(宽)*1750mm(厚)*325mm(高)</div>
      <div class="center_two_e">1拖1带雨棚整体尺寸：1505mm(宽)*1750mm(厚)*2225mm(高)</div>
      <div class="center_two_e">1拖2带雨棚整体尺寸：2355mm(宽)*1750mm(厚)*2225mm(高)</div>
      <div class="center_two_e">1拖3带雨棚整体尺寸：3055mm(宽)*1750mm(厚)*2225mm(高)</div>
      <div class="center_two_e">1拖4带雨棚整体尺寸：3755mm(宽)*1750mm(厚)*2225mm(高)</div>
      <div class="center_two_e">投口尺寸：大副柜:600*290mm；小副柜:450*290mm；纸类:600*190mm；投口高度:1085mm</div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../assets/images/home_center_adorn.png">
      </div>

      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        居民社区，公共场所，小区宽阔区域
      </div>
      <div class="center_two_d">分类</div>
      <div class="center_two_e">
        纸类I织物I金属I塑料I玻璃I有害垃圾<span
          style="font-size: 24px;color: #FE0303;font-family: Source Han Sans CN;font-weight: 400;">可定制</span>
      </div>

      <div class="center_two_d">功能</div>
      <div class="center_two_f">
        <img src="../assets/images/blhsg03_center_002.png">
      </div>

    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left">交互</div>
        <div class="three_body_left_right">电容触摸功能，可以与用户进行互动。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">语音</div>
        <div class="three_body_right_right" style="text-align: right">使用TTS语音进行播报功能。</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">称重</div>
        <div class="three_body_left_right">投放物品称重功能，对每次投递的物品进行单独称重，更加准确。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">报警</div>
        <div class="three_body_right_right" style="text-align: right">满溢报警，门的状态实时反馈。</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">防夹</div>
        <div class="three_body_left_right">防夹手检测。</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">积分</div>
        <div class="three_body_right_right" style="text-align: right">配备21.5寸屏，及时显示用户信息和积分等信息。</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">照明</div>
        <div class="three_body_left_right">箱体外部有指示灯(兼做照明),每个箱体内部都有照明灯,投递门开启后自动打开,投递门关闭后自动关闭。</div>
      </div>

    </div>

    <div class="detail_center_four">
      <img style="width: 80%;margin-top: 24px" src="../assets/images/blhsg03_center_003.png"/>
      <div class="center_four_text">(可定制)</div>
    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../assets/images/hc3620_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })
  },
}
</script>

<style lang="less" scoped>

@import "../assets/css/detailCommon";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 470px;

    .oneBodyImgCls {
      width: 100%;
      height: 470px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 546px;

    .oneBodyImgCls {
      width: 100%;
      height: 546px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 712px;

    .oneBodyImgCls {
      width: 100%;
      height: 712px;
    }
  }
}

.center_one_body_current {
  display: flex;

  .oneBodyImgCls {
  }
}
</style>